import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export function ButtonPrimitive({ ref, className, children, hoverShadow, interactableVariant = 'default', type = 'button', __dangerouslySetTabIndex, ...props }) {
    return (_jsx("button", { ...props, type: type, ref: ref, ...(__dangerouslySetTabIndex !== undefined ? { tabIndex: __dangerouslySetTabIndex } : {}), className: classNames('reset', hoverShadow &&
            (hoverShadow === 'sm'
                ? 'enabled:hover:shadow-sm-hover'
                : 'enabled:hover:shadow-md-hover'), interactableVariant === 'alt' ? 'interactable-alt' : 'interactable', {
            'pointer-events-none': props.disabled,
        }, className), children: children }));
}
//# sourceMappingURL=index.js.map